<script>

import StrWorker from "@/components/StrWorker.vue";
import AnnexSelect from "@/views/PaySlipSynthesis/Components/AnnexSelect.vue";
import useValidation from "@/use/Validation";
import useTools from "@/use/Tools";
import useSharedData from "@/use/SharedData";
import {ref} from "vue";
import useSharedMethod from "@/use/SharedMethod";
import axios from "axios";

export default {
    components: {AnnexSelect, StrWorker},
    props: {
        annexId: Number,
    },
    setup(props) {
        const {mxRules} = useValidation();
        const {$refs} = useTools();
        const {transformFilterValues} = useSharedMethod();
        const {loading, inputColor, backgroundColor} = useSharedData();

        const modelId = ref(null);
        const models = [
            {id: 'PAY_SLIP', name: 'Modèle bulletin de paie'},
            // {id: 'WORKER_IN_COLUMNS', name: 'Modèle salariés en colonnes'},
        ];

        const data = ref({
            workers: [],
            filter: {},
        });


        function print() {
            if ($refs.form.validate()) {
                loading.value = true;
                let workerIds = data.value.workers.map((w) => w.id);
                axios.post(`/printed/journalPay/${props.annexId}`, workerIds, {
                    responseType: "blob",
                    params: transformFilterValues(data.value.filter),
                }).then((response) => {
                    const blob = response.data;
                    const link = document.createElement("a");
                    link.href = window.URL.createObjectURL(blob);
                    //this.objectURL = link.href;
                    window.open(link, "_blank");
                }).finally(() => {
                    loading.value = false;
                });
            }
        }

        return {
            mxRules,
            loading,
            inputColor,
            backgroundColor,
            models,
            modelId,
            data,
            print,
        }
    },
};
</script>

<template>
    <str-worker v-model="data">
        <v-form ref="form" lazy-validation>
            <v-row dense>
                <v-col cols="12">
                    <w-label :label="$t('common.pay')" required/>
                    <annex-select
                        v-model="annexId"
                        :rules="[mxRules.required]"
                    />
                </v-col>
                <!--<v-col cols="12">
                    <strong>Modèle *</strong>
                    <v-select
                            v-model="modelId"
                            :items="models"
                            item-value="id"
                            item-text="name"
                            outlined
                            dense
                            :color="inputColor"
                            :background-color="backgroundColor"
                            :rules="[mxRules.required]"
                    ></v-select>
                </v-col>-->
                <v-col cols="12">
                    <w-btn
                        color="teal"
                        :text="$t('common.print')"
                        icon="mdi-printer"
                        block
                        :loading="loading"
                        @press="print"
                    />
                </v-col>
            </v-row>
        </v-form>
    </str-worker>
</template>